/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import radiantGreenUrl from '../../../assets/gems/radiant_green.svg?inline';
export function RadiantGreen({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: radiantGreenUrl,
        alt: "RadiantGreenImage"
    });
}
